import { useEffect, useState } from 'react';

/**
 * 컴포넌트가 화면에 들어왔는 지에 대한 여부를 반환하는 함수
 * @param {React.RefObject<HTMLElement} ref - 컴포넌트가 참조하는 DOM 요소의 ref 객체
 * @returns {boolean} 화면에 들어왔는 지 여부를 나타내는 불리언 값
 */
export const checkOnScreen = (ref) => {
  const [on, setOn] = useState(true);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => setOn(entries.some((el) => el.isIntersecting)),
      { threshold: 0 }
    );

    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, []);
  return on;
};
